/**
* [Flags]
*/
export var Views;
(function (Views) {
    Views[Views["None"] = 0] = "None";
    Views[Views["Data"] = 2] = "Data";
    Views[Views["Matrix"] = 4] = "Matrix";
    Views[Views["Charts"] = 8] = "Charts";
    Views[Views["Tiles"] = 16] = "Tiles";
    Views[Views["Blurb"] = 32] = "Blurb";
    Views[Views["Text"] = 64] = "Text";
    Views[Views["Calendar"] = 128] = "Calendar";
    Views[Views["Cells"] = 256] = "Cells";
    Views[Views["HierarchicalView"] = 512] = "HierarchicalView";
    Views[Views["ColumnsView"] = 1024] = "ColumnsView";
})(Views || (Views = {}));
;
